import { FC } from 'react';
import styled from 'styled-components';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { SlidesViewFilters, isDefaultFilters } from '../../../components/FolderManager/Components/FolderManagerSlidesViewFilters';

interface Props {
  filters: SlidesViewFilters;
  active: boolean;
  defaultFilters?: SlidesViewFilters;
  onClick: () => void;
}

const StyledButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 0 8px;
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: 600;
  font-family: inherit;
  color: inherit;
  background: white;
  border: 1px solid ${({ $active, theme }) => ($active ? theme.palette.primaryButton : theme.palette.cardBorderDarker)};
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primaryButton};
  }

  svg {
    font-size: 14px !important;
  }

  svg:last-child {
    font-size: 20px !important;
  }
`;

const StyledActiveDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.primaryButton};
  flex-shrink: 0;
`;

export const SlidesFiltersSelector: FC<Props> = ({ filters, active, defaultFilters, onClick }) => {
  const hasActiveFilters = !isDefaultFilters(filters, defaultFilters);

  return (
    <StyledButton type="button" $active={active} onClick={onClick}>
      <FilterAltOutlinedIcon />
      Filters
      {hasActiveFilters && <StyledActiveDot />}
      {active ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
    </StyledButton>
  );
};
